<template>
  <div class="main_container" style="font-size: 14px">
    <van-nav-bar
        title="我订阅的设备"
        left-text="返回"
        left-arrow
        :right-text="rightTxt"
        @click-left="$router.push({name:'mainFunc'})"
        @click-right="onClickRight"
        :fixed="true"
      />
    <div class="body">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div style="min-height: calc(100vh)">
          <table class="ui unstackable table" style="text-align: center;border-radius: 0">
            <thead>
              <tr>
                <th style="width: 80px">#</th>
                <th>名称</th>
                <th style="width: 50px" v-if="mode=='edit'">全选</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="mode!='edit'" v-for="(sn,idx) in subscribeStations" @click="$router.push({name:'station_info',params:{station_id:sn.ID}})">
                <td>{{idx+1}}</td>
                <td>{{sn.Name}}</td>
              </tr>
              <tr v-if="mode=='edit'" v-for="(sn,idx) in subscribeStations">
                <td>{{idx+1}}</td>
                <td>{{sn.Name}}</td>
                <td><input v-model="sn.choose" type="checkbox" id="sn.ID"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </van-pull-refresh>
      <img @click="$router.push({name:'subscribei'})" style="position: fixed;bottom: 8%;right: 4%;border-radius: 48px;display: inline-block; box-shadow: 0px 0px 2px 0px;background: white; width: 36px;z-index: 10" src="static/icon/plus.png">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import { Toast, Dialog } from 'vant';
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      isLoading:false,
      subscribeStations:[],
      mode:''
    }
  },
  mounted(){
    this.getMySubscribeStations()
  },
  computed:{
    rightTxt(){
      if(this.mode == 'edit'){
        return '完成'
      }else{
        return '编辑'
      }
    }
  },
  methods:{
    getMySubscribeStations(){
      var self = this
      return this.axios_base.get("session/getMySubscribeStations").then(function(resp){
        self.subscribeStations = resp.data
        for (var i in self.subscribeStations){
          self.subscribeStations[i].choose = false
        }
      })
    },
    onRefresh:async function(){
      var self = this
      this.getMySubscribeStations().then((x)=>{
        self.isLoading = false
      })

    },
    onClickRight(){
      var self = this
      if(this.mode != 'edit'){
        this.mode = 'edit'
      }else{
        var station_ids=[]
        for(var i in this.subscribeStations){
          if (this.subscribeStations[i].choose == true){
            station_ids.push(this.subscribeStations[i].ID)
          }
        }
        if(station_ids.length==0){
          self.mode = 'finished'
          return 
        }
        Dialog.confirm({
          title: '提示',
          message: '确定删除？'
        }).then(() => {
          
          var station_ids_str = station_ids.join(',')
          console.log(station_ids_str)
          self.axios_base.get('session/unsubscribe?station_ids='+station_ids_str).then(function(resp){
            console.log(resp.data)
            self.mode = 'finished'
            self.getMySubscribeStations()
          })
        }).catch(() => {
          self.mode = 'finished'
          for (var i in self.subscribeStations){
            self.subscribeStations[i].choose = false
          }
        });
      }
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.msg_num{
  display: inline-block;
  text-align: center;
  border: 1px solid black red;
  border-radius: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  background:red;
  color: white;
  position: absolute;
  transform: translate(-50%,-50%);
  top: 50%;
  right: 0%
}
</style>



// WEBPACK FOOTER //
// src/pages/application/subscribe/mySubscribeSns.vue